import { PasswordResetLinkCreatorComponent } from 'components';
import { APP_ROUTES } from 'constants/AppRoutes';

const PasswordResetPandit = () => (
	<PasswordResetLinkCreatorComponent signInLink={APP_ROUTES.SIGN_IN_PANDIT} />
);

export default PasswordResetPandit;
